import { translate, useLocale } from "../../localization";
import { useState } from "react";
import { AppButton } from "../ui";
import "./SessionCodeInput.scss";

const SessionCodeInput = ({ }) => {
  useLocale();
  const [code, setCode] = useState("");

  const handleInputChange = (event) => {
    setCode(event.target.value);
  }

  const goToSession = (event) => {
    event.preventDefault();
    if (/^\d{4}$/.test(code)) window.location = `/public/sessions/${code}`;
  }

  return (
    <div className="form-holder">
      {/* Want to check out the dashboard? */}
      <form onSubmit={goToSession} className="code-form">
        <input
          type="text"
          className="input-field"
          placeholder={translate("Enter session code")}
          value={code}
          inputMode="numeric"
          pattern="[0-9]{4}"
          maxLength={4}
          required
          onChange={handleInputChange}
        />
        <AppButton type="submit" kind="primary" className="submit-button">
          ➔
        </AppButton>
      </form>
    </div>
  );
}

export default SessionCodeInput;
